import { useQueries, useQueryClient } from "@tanstack/react-query";

import { getFootprintingDairyFeedProduction, getFootprintingDairyFeedProductionAdmin } from "services";

import { getEnvironment } from "utils";

import { FOOTPRINTING_DAIRY_FEED_PRODUCTION } from "consts";

export const useGetFootprintingDairyFeedProductions = (feedInformationIds: string[] = []) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();

  return useQueries(
    {
      queries: feedInformationIds.map((feedInformationId) => ({
        queryKey: [FOOTPRINTING_DAIRY_FEED_PRODUCTION, feedInformationId, isAdmin],
        queryFn: () => (isAdmin ? getFootprintingDairyFeedProductionAdmin(feedInformationId) : getFootprintingDairyFeedProduction(feedInformationId)),
        enabled: !!feedInformationId,
        staleTime: 0,
        gcTime: 0,
      })),
    },
    queryClient
  );
};
